import isEmpty from './isEmpty.js'
import store from '../store/index'
//-----------------------------------------
// convert add sorcery casting skill actions
//-----------------------------------------
export default function convertAddSorceryCastingSkillActions(changed_skills, changed_spells = []) {
  //--------------------------------------------------------------------------
  // As with runecasting, sorcery casting CharacterSkill rows are auto-created
  // in the backend via signals when casting-applicable sorcery spells are
  // added. Any local ADD entries for these casting skills should therefore be
  // treated as UPDATEs against the backend-created rows. If the originating
  // spell is no longer being saved, drop the skill ADD entirely so a deleted
  // sorcery spell cannot leave behind a standalone casting skill.
  //--------------------------------------------------------------------------
  if (isEmpty(changed_skills)) {
    return []
  }

  // get static Sorcery Casting skill so we can match on its id in payload
  const sorceryCasting = store.getters['characters/getSkill']('Sorcery Casting')
  if (!sorceryCasting) {
    console.error('convertAddSorceryCastingSkillActions: Sorcery Casting skill not found in store')
    return changed_skills
  }
  const sorcerySkillId = sorceryCasting.id
  const activeSpellChangeNames = new Set(
    (Array.isArray(changed_spells) ? changed_spells : [])
      .filter((entry) => entry && entry.action !== 'DELETE' && entry.name)
      .map((entry) => entry.name),
  )

  //-----------------
  // convert actions
  //-----------------
  const converted = changed_skills
    .map((r) => {
      // only adjust ADDs for the Sorcery Casting static skill
      if (r.action === 'ADD' && r.payload && r.payload.skill === sorcerySkillId) {
        if (!activeSpellChangeNames.has(r.name)) {
          return null
        }
        //---------------------------------------------------------------------
        // if ticks & training = zero - remove entry (backend default is 0/0)
        //---------------------------------------------------------------------
        if (r.payload.ticks === 0 && r.payload.training === 0) {
          return null
        }
        //----------------------------
        // else convert ADD to UPDATE
        //----------------------------
        return {
          action: 'UPDATE',
          // id will be resolved server-side based on the spell/casting
          // relationship (we keep name as the key, which for casting
          // skills is the spell name via display_name).
          id: null,
          name: r.name,
          payload: {
            ticks: r.payload.ticks,
            training: r.payload.training,
          },
        }
      }
      return r
    })
    //---------------------
    // remove null entries
    //---------------------
    .filter((r) => r !== null)

  return converted
}
